import { configureStore } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import authReducer from './modules/authSlice';
// import templateReducer from './modules/template';
import chatSettingReducer from './modules/chatSettingSlice';
import utilsReducer from './modules/utilsSlice';
import faqReducer from './modules/faqSlice';
// 创建 store
const store = configureStore({
  reducer: {
    auth: authReducer,
    // template: templateReducer,
    chatSetting: chatSettingReducer,
    utils: utilsReducer,
    faq: faqReducer,
    // 示例：添加新的 reducer
    // user: userReducer,
    // ... 其他 reducer
  },
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware({
  //     serializableCheck: {
  //       // 可以在这里添加需要忽略序列化检查的action和path
  //       ignoredActions: [],
  //       ignoredPaths: [],
  //     },
  //   }),
  // devTools: process.env.NODE_ENV !== 'production',
});

// 从 store 本身推断 `RootState` 和 `AppDispatch` 类型
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// 在整个应用程序中使用，而不是简单的 `useDispatch` 和 `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// 获取最新的store状态的辅助函数
export const getLatestState = (): RootState => {
  return store.getState();
};

export default store;

// 使用示例：
// 在组件中使用 Redux store

/*
import React from 'react';
import { useAppSelector, useAppDispatch } from '@/store';
import { login, logout, setWilllinksToken } from '@/store/authSlice';

const ExampleComponent: React.FC = () => {
  // 使用自定义钩子获取状态
  const auth = useAppSelector((state) => state.auth);
  // 使用自定义钩子获取dispatch
  const dispatch = useAppDispatch();

  // 登录操作示例
  const handleLogin = () => {
    dispatch(login('user@example.com'));
  };

  // 登出操作示例
  const handleLogout = () => {
    dispatch(logout());
  };

  // 设置token示例
  const setToken = () => {
    dispatch(setWilllinksToken('example-token-123'));
  };

  return (
    <div>
      <p>认证状态: {auth.isAuthenticated ? '已登录' : '未登录'}</p>
      <p>用户: {auth.user || '无'}</p>
      <p>Token: {auth.willlinksToken || '无'}</p>
      <button onClick={handleLogin}>登录</button>
      <button onClick={handleLogout}>登出</button>
      <button onClick={setToken}>设置Token</button>
    </div>
  );
};

export default ExampleComponent;
*/

